// ./src/components/features/Themes/ThemeFormModal/ThemeSectionsList.tsx
import React from "react";
import { Stack, UnstyledButton, Text, Box } from "@mantine/core";
import { ThemeSectionConfig } from "./ThemeSectionEditor";

export interface ThemeSectionsListProps {
  /** Array of section configurations */
  sections: ThemeSectionConfig[];

  /** Currently selected section key */
  selectedSectionKey: string;

  /** Callback when a section is selected */
  onSelectSection: (sectionKey: string) => void;
}

export const ThemeSectionsList: React.FC<ThemeSectionsListProps> = ({
  sections,
  selectedSectionKey,
  onSelectSection,
}) => {
  if (!sections || sections.length === 0) {
    return (
      <Box p="md">
        <Text size="sm" c="dimmed">
          No sections available
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap={4}>
      {sections.map((section) => {
        const isSelected = section.sectionKey === selectedSectionKey;

        return (
          <UnstyledButton
            key={section.sectionKey}
            onClick={() => onSelectSection(section.sectionKey)}
            style={(theme) => ({
              padding: theme.spacing.sm,
              borderRadius: theme.radius.sm,
              backgroundColor: isSelected
                ? theme.colors.blue[0]
                : "transparent",
              border: `1px solid ${
                isSelected ? theme.colors.blue[3] : "transparent"
              }`,
              cursor: "pointer",
              transition: "all 0.15s ease",
              "&:hover": {
                backgroundColor: isSelected
                  ? theme.colors.blue[1]
                  : theme.colors.gray[0],
              },
            })}
          >
            <Stack gap={4}>
              <Text
                size="sm"
                fw={isSelected ? 600 : 500}
                c={isSelected ? "blue.7" : "dark"}
              >
                {section.sectionName}
              </Text>
              {section.description && (
                <Text size="xs" c="dimmed" lineClamp={2}>
                  {section.description}
                </Text>
              )}
            </Stack>
          </UnstyledButton>
        );
      })}
    </Stack>
  );
};
